import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import logo from "../images/logo.png"
import "./header.css"

const Header = ({ siteTitle }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          typeAreaWidth
        }
      }
    }
  `)
  const [active, setActive] = useState(false)
  const [navBarActiveClass, setNavBarActiveClass] = useState('')
  const toggleHamburger = () => {
    // toggle the active boolean in the state
    setNavBarActiveClass(!active ? 'is-active' : '')
    setActive(!active)
  }

  return (
      <nav className="navbar" role="navigation" aria-label="main navigation" style={{padding: '0 22x'}}>
        {/* <div style={{maxWidth: site.siteMetadata.typeAreaWidth, margin: '0 auto'}}> */}
          <div className="navbar-brand">
            <Link className="navbar-item" to="/">
              <img src={logo} alt="海华鑫安" style={{marginBottom: '0'}}/>
            </Link>
            <a
              className={`navbar-burger burger ${navBarActiveClass}`}
              onClick={toggleHamburger}
              data-target="navbarBasicExample">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div id="navbarBasicExample" className={`navbar-menu ${navBarActiveClass}`}>
            <div className="navbar-end has-text-centered">
              <Link className="navbar-item" to="/news" activeClassName="active">
                新闻中心
              </Link>
              <Link className="navbar-item" to="/business" activeClassName="active">
                业务体系
              </Link>
              <Link to="/join" className="navbar-item" activeClassName="active">
                加入我们
              </Link>
              <Link to="/about" className="navbar-item" activeClassName="active">
                关于我们
              </Link>
              <Link to="/contact" className="navbar-item" activeClassName="active">
                联系我们
              </Link>
            </div>
          </div>
        {/* </div> */}
      </nav>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
